// removed by extract-text-webpack-plugin
module.exports = {"container":"Teleconference__container___yubrao-","phone":"Teleconference__phone___1fxRuvu","title":"Teleconference__title___-rabEGx"};